import { Component, Input, Output, OnInit, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { AddQuestionLevelTimeDirective, ReSizeDirective, OnCreate } from '../app.taketestdirective'
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'
declare var FunctionCall: any, Message: any, Summary: any, Test: any, submitButtonCultureVal: any, nextbuttonCutlureVal: any, bookmarkButtonVal: any, previousbuttonCutlureVal: any, SubmitAnsCultVal: any, isSingleQuestionPreview: any, ClearVal: any;
@Component({
    selector: 'app-test-buttons',
    templateUrl: 'app.buttons.html'
})
export class ButtonsCommonComponent implements AfterViewInit {
    public CallClickEvents: any;
    public CallConfirmSubmit: any;
    public submitButtonVal: any = "";
    public nextVal: any = "";
    public bookmarkVal: any = "";
    public previousVal: any = "";
    public SubmitAnsVal: any = "";
    public isSingleQuestion: any = "";
    public Clear: any = "";

    ngAfterViewInit() {
        this.submitButtonVal = submitButtonCultureVal;
        this.bookmarkVal = bookmarkButtonVal;
        this.nextVal = nextbuttonCutlureVal;
        this.previousVal = previousbuttonCutlureVal;
        this.SubmitAnsVal = SubmitAnsCultVal;
        this.isSingleQuestion = isSingleQuestionPreview;
        this.Clear = ClearVal;   
    }
    //from parent
    @Input() item: any;
    @Input() TestInfo: any;
    @Input() isEnableSubmitButton: any;
    @Input() IsShowNextReviewButton: any;
    @Input() IsShowPreviousReviewButton: any;
    @Input() quesNum: any;
    @Input() TestPrefController: any;
    // from child
    @Output() ParentFunctionCall = new EventEmitter();
    @Output() ParentShowNext = new EventEmitter();
    @Output() ParentShowPrevious = new EventEmitter();

    FunctionCall(arg1, arg2, arg3) {
        var obj = {
            arg1: arg1,
            arg2: arg2,
            arg3: arg3
        }
        this.ParentFunctionCall.emit(obj);
    }
    ShowNext() {
        this.ParentShowNext.emit();
    }
    ShowPrevious() {
        this.ParentShowPrevious.emit();
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/QuestionCommon/app.buttons.ts